<template>
  <div class="d-flex justify-space-around">
    <custom-technician-chips
      :label="
        generateMessage('properties_360.fields.mnt_responsible_technician')
      "
      :technician="mntResponsibleTech"
      :loading="loading"
      @click="$emit('click', mntResponsibleTech)"
    />
    <custom-technician-chips
      :label="generateMessage('properties_360.fields.mnt_resp_buddy')"
      :technician="mntResponsibleTechBuddy"
      :loading="loading"
      @click="$emit('click', mntResponsibleTechBuddy)"
    />
    <custom-technician-chips
      :label="
        generateMessage('properties_360.fields.maintenance.tech_in_charge')
      "
      :loading="loading"
      :technician="techInCharge"
      @click="$emit('click', techInCharge)"
    />
    <custom-technician-chips
      label="Astreinte"
      :loading="loading"
      :technician="firstOnCall"
      @click="$emit('click', firstOnCall)"
    />
  </div>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import CustomTechnicianChips from '@/components/selects/technician/CustomTechnicianChips';
import Technician from '@/store/modules/technicians/model';
import TechniciansResponsibleService from '@/services/services/techniciansResponsible.service';

export default {
  name: 'property-default-tech-select',
  components: { CustomTechnicianChips },
  methods: {
    generateMessage,
  },
  props: {
    propertyId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    propertyId: {
      handler(id) {
        this.loading = true;
        this.mntResponsibleTech = new Technician({});
        this.techInCharge = new Technician({});
        this.mntResponsibleTechBuddy = new Technician({});
        this.firstOnCall = new Technician({});
        TechniciansResponsibleService.getTechnicians(id)
          .then((res) => {
            this.mntResponsibleTech = res.mntResponsibleTech;
            this.techInCharge = res.techInCharge;
            this.mntResponsibleTechBuddy = res.mntResponsibleTechBuddy;
            if (res.onCallTechs[0]) {
              this.firstOnCall = res.onCallTechs[0];
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      immediate: true,
    },
  },
  data: () => ({
    mntResponsibleTech: new Technician({}),
    loading: false,
    techInCharge: new Technician({}),
    mntResponsibleTechBuddy: new Technician({}),
    firstOnCall: new Technician({}),
  }),
};
</script>
